import { render, staticRenderFns } from "./myheadWhite.vue?vue&type=template&id=c5f16042&scoped=true"
import script from "./myheadWhite.vue?vue&type=script&lang=js"
export * from "./myheadWhite.vue?vue&type=script&lang=js"
import style0 from "./myheadWhite.vue?vue&type=style&index=0&id=c5f16042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f16042",
  null
  
)

export default component.exports